"use client";

import React, { useEffect, useState } from "react";
import { ProductData } from "@/lib/5874/types";
import ProductRecommendationCarousel from "../ProductRecommendationCarousel/ProductRecommendationCarousel";
import { getProductRelatedItems } from "@/lib/bigcommerce/product";

interface RelatedItemsCarouselProps {
	productId: number;
	relatedItems?: ProductData[];
}

const RelatedItemsCarousel: React.FC<RelatedItemsCarouselProps> = ({
	productId,
	relatedItems = [],
}) => {
	// const [relatedItems, setRelatedItems] =
	// 	useState<ProductData[]>(relatedProducts);
	// const [isResponseReceived, setIsResponseReceived] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	// const fetchRelatedItems = async () => {
	// 	try {
	// 		setIsLoading(true);
	// 		const relatedItemsResponse = await getProductRelatedItems(productId);
	// 		setRelatedItems(relatedItemsResponse);
	// 		setIsResponseReceived(true);
	// 		setIsLoading(false);
	// 	} catch (error) {
	// 		setIsLoading(false);
	// 		console.log("Could not fetch related items");
	// 	}
	// };

	// useEffect(() => {
	// 	if (productId && relatedProducts.length > 0) {
	// 		fetchRelatedItems();
	// 	}
	// }, [productId, relatedItems]);

	if (!relatedItems.length) return null;
	return (
		<ProductRecommendationCarousel
			placementProductId={String(productId)}
			searchSpringId='related-items'
			products={relatedItems}
			title='Related Items'
			useProductCards
			isLoading={isLoading}
		/>
	);
};

export default RelatedItemsCarousel;
